import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";
import ViewInfo from "components/reusable/ViewInfo";

const EmployeeView = ({ setEmployeeView, currentItem }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full min-w-[940px] max-h-[96vh] overflow-y-auto bg-white outline-none focus:outline-none">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("O_VIEW_USER")}</h3>
                <button className=" ml-auto flex items-center justify-center text-3xl text-black border-2 rounded-full h-8 w-8 float-right leading-none font-extralight outline-none focus:outline-none" onClick={() => setEmployeeView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <h3 className="text-xl font-semibold">Employee details</h3>
                <div className="grid grid-cols-3">
                  {/* <ViewInfo label="Employee ID" value={currentItem?.Employee?.employeeId || ""} /> */}
                  <ViewInfo label="Employee ID" value={currentItem?.employmentStatus === "terminated" ? `${currentItem?.Company.name.substring(0, 3)}${currentItem.Employee._id.toString().slice(-3)}` :currentItem?.Employee?.employeeId} />
                  <ViewInfo label="Employee name" value={currentItem?.Employee?.name || ""} />
                  <ViewInfo label="Email ID" value={currentItem?.Employee?.email || ""} />
                  <ViewInfo label="Year of experience" value={currentItem?.yearOfExperiece || ""} />
                  <ViewInfo label="DOB" value={dayjs(currentItem?.Employee?.dob).format("MM-DD-YYYY")} />
                  <ViewInfo label="Country" value={currentItem.EmployeeCountry?.name || ""} />
                  <ViewInfo label="State" value={currentItem.EmployeeState?.name || ""} />
                  <ViewInfo label="City" value={currentItem.Employee?.city || ""} />
                  <ViewInfo label="Skills" value={currentItem.Skills?.map((item) => item?.name).join(", ") || ""} />
                  <ViewInfo label="Job title" value={currentItem.Job?.name || ""} />
                  <ViewInfo label="Department" value={currentItem.Department?.name || ""} />
                  <ViewInfo label="Employment length [in days]" value={currentItem?.Job?.employmentLength || ""} />
                  <ViewInfo label="Accepted and rejected date" value={dayjs(currentItem?.acceptedRejectedAt).format("MM-DD-YYYY ")} />
                  <ViewInfo label="Status" value={startCase(currentItem.employmentStatus === "terminated" ? currentItem.employmentStatus : currentItem?.status) || "N/A"} />
                  <ViewInfo label="Duration Type" value={currentItem.duration || ""} />
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>LinkedIn</strong>
                      <h6>{currentItem.Employee?.linkedInLink ? (
                        <a href={currentItem.Employee.linkedInLink} target="_blank" rel="noopener noreferrer">
                          View Profile
                        </a>
                      ) : (
                        <span>LinkedIn profile not added</span>
                      )}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-solid border-slate-200 rounded-b flex items-center justify-center p-6">
                <button onClick={() => setEmployeeView(false)} className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button">
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default EmployeeView;
